angular
    .module('tradersyard')
    .factory('friend-read-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        filter.set(filter.get());
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    get: function () {
                        hash = $flex.$hash.get();

                        return ['friend', 'request'].indexOf(hash) !== -1 ? hash : 'friend';
                    },
                    set: function (name) {
                        tab = name;

                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);
                        $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('friend-query-ctrl', [
        '$rootScope',
        '$scope',
        'graph-friend-factory',
        'friend-read-filter',
        '$flex',
        '$flex.array',
        '$rootScope',
        'RequestManagerFactory',
        'GuidFactory',
        'WebSocket',
        'MeetingService',
        function (
            $rootScope,
            $scope,
            $factory,
            $filter,
            $flex,
            $array,
            $root,
            RequestManagerFactory,
            GuidFactory,
            $socket,
            MeetingService
        ) {
            $scope.requests = 0;
            $scope.friends_count = 0;

            angular.extend($scope, $flex.data);

            $scope.friends = [];
            $scope.process = false;
            $scope.filter = $filter;
            $scope.space = 'me';
            $scope.params = {
                friends: {
                    page: 0,
                    let: 0,
                    limit: 25,
                },
            };

            $scope.Request = RequestManagerFactory.Init(
                $scope.space === 'me' ? $scope.$parent.me.id : $scope.space,
                'user',
                $scope
            );
            $scope.Request.Count = $scope.requests;
            $scope.Guid = GuidFactory.Generate();

            $scope.init = function (space) {
                if (space) $scope.space = space;

                $scope.query();
            };

            $scope.$entry = function (space) {
                if (space) $scope.space = space;
            };

            $scope.load = {
                friends: function (next) {
                    ++$scope.params.friends.page;
                    $scope.process = true;

                    $factory
                        .entry('user', $scope.space)
                        .query({
                            params: $scope.params.friends,
                        })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.friends = $scope.friends.concat(response.data.data);

                                if (next) next();
                            }

                            $scope.process = false;
                        });
                },
                requests: function (next) {
                    $scope.Request.Query(next);
                },
            };

            $scope.callMeeting = function (meetingId) {
                var meeting = {
                    id: meetingId,
                };
                MeetingService.startCall(meeting);
            };

            $scope.unfriend = function (node) {
                $scope.process = 1;

                $factory
                    .entry('user', $scope.space)
                    .unfriend(node.id)
                    .then(function (response) {
                        if (response.data.state === 0) {
                            $scope.friends = $array.$splice($scope.friends, node, 'id');

                            --$scope.friends_count;
                        }

                        $scope.process = 0;
                    });
            };

            $scope.filter.on.change = function () {
                $flex.$scroll.switch($filter.tab());
            };

            $scope.$on('touch:friend', function () {
                $scope.load.friends();
            });

            $scope.$on('touch:request', function () {
                $scope.load.requests();
            });

            $scope.$on('friend-query-update', function () {
                $scope.query();
            });

            $socket.on('me:friend:friend', function (data) {
                // if (parseInt(data.place.id) === parseInt($scope.node.id)) {
                ++$scope.friends_count;
                ++$scope.params.friends.let;
                $scope.friends.unshift(data.node);
                if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                    $rootScope.$apply();
                }
                // }
            });

            $socket.on('me:friend:unfriend', function (data) {
                // if (parseInt(data.place.id) === parseInt($scope.node.id)) {
                --$scope.friends_count;
                --$scope.params.friends.let;

                $scope.friends.forEach(function (friend, i) {
                    if (friend.id === data.node.id) {
                        $scope.friends.splice(i, 1);
                    }
                });

                if ($rootScope.$$phase !== '$apply' && $rootScope.$$phase !== '$digest') {
                    $rootScope.$apply();
                }
                // }
            });

            $socket.emit('join:user', [$scope.space === 'me' ? $scope.$parent.me.id : $scope.space]);
        },
    ]);
